let initialState = (() => {
  try {
    const userData = localStorage.getItem("user");
    if (userData) {
      const parsedData = JSON.parse(userData);
      // Ensure we have a valid array and the first element exists
      return (Array.isArray(parsedData) && parsedData.length > 0) ? parsedData[0] : 0;
    }
    return 0;
  } catch (error) {
    // If JSON parsing fails, return default value
    console.warn("Failed to parse user data from localStorage:", error);
    return 0;
  }
})();

const setUserlog = (state = initialState, action) => {
  // console.log(localStorage.getItem("user"));

  switch (action.type) {
    case "LOGUSER":
      return action.parm;
    case "RESET":
      return initialState; //Always return the initial state
    default:
      return state;
  }
};

export default setUserlog;
